export default {
  position: {
    notes: 'Position for a sensor',
    message: 'Position',
    values: {
      EBCL: {
        notes: 'Sensor position EBCL',
        message: 'Exciter beam center left',
      },
      EBCR: {
        notes: 'Sensor position EBCR',
        message: 'Exciter beam center right',
      },
      EBDC: {
        notes: 'Sensor position EBDC',
        message: 'Exciter beam discharge center',
      },
      EBDL: {
        notes: 'Sensor position EBDL',
        message: 'Exciter beam discharge left',
      },
      EBDR: {
        notes: 'Sensor position EBFR',
        message: 'Exciter beam discharge right',
      },
      EBFC: {
        notes: 'Sensor position EBFC',
        message: 'Exciter beam feed center',
      },
      EBFL: {
        notes: 'Sensor position EBFL',
        message: 'Exciter beam feed left',
      },
      EBFR: {
        notes: 'Sensor position EBFR',
        message: 'Exciter beam feed right',
      },
      EBC: {
        notes: 'Sensor position EBR',
        message: 'Exciter beam center',
      },
      EBL: {
        notes: 'Sensor position EBL',
        message: 'Exciter beam left',
      },
      EBR: {
        notes: 'Sensor position EBR',
        message: 'Exciter beam right',
      },
      LB: {
        notes: 'Sensor position LB',
        message: 'Left beam',
      },
      LBD: {
        notes: 'Sensor position LBD',
        message: 'Left beam discharge',
      },
      LBF: {
        notes: 'Sensor position LBF',
        message: 'Left beam feed',
      },
      LC: {
        notes: 'Sensor position LC',
        message: 'Left center',
      },
      LCB: {
        notes: 'Sensor position LCB',
        message: 'Left center bottom',
      },
      LCT: {
        notes: 'Sensor position LCT',
        message: 'Left center top',
      },
      LD: {
        notes: 'Sensor position LD',
        message: 'Left discharge',
      },
      LDB: {
        notes: 'Sensor position LDB',
        message: 'Left discharge bottom',
      },
      LDT: {
        notes: 'Sensor position LDT',
        message: 'Left discharge top',
      },
      LF: {
        notes: 'Sensor position LF',
        message: 'Left feed',
      },
      LFB: {
        notes: 'Sensor position LFB',
        message: 'Left feed bottom',
      },
      LFT: {
        notes: 'Sensor position LFT',
        message: 'Left feed top',
      },
      RB: {
        notes: 'Sensor position RB',
        message: 'Right beam',
      },
      RBD: {
        notes: 'Sensor position RBD',
        message: 'Right beam discharge',
      },
      RBF: {
        notes: 'Sensor position RBF',
        message: 'Right beam feed',
      },
      RC: {
        notes: 'Sensor position RC',
        message: 'Right center',
      },
      RCB: {
        notes: 'Sensor position RCB',
        message: 'Right center bottom',
      },
      RCT: {
        notes: 'Sensor position RCT',
        message: 'Right center top',
      },
      RD: {
        notes: 'Sensor position RD',
        message: 'Right discharge',
      },
      RDB: {
        notes: 'Sensor position RDB',
        message: 'Right discharge bottom',
      },
      RDT: {
        notes: 'Sensor position RDT',
        message: 'Right discharge top',
      },
      RF: {
        notes: 'Sensor position RF',
        message: 'Right feed',
      },
      RFB: {
        notes: 'Sensor position RFB',
        message: 'Right feed bottom',
      },
      RFT: {
        notes: 'Sensor position RFT',
        message: 'Right feed top',
      },
    },
  },
  designation: {
    notes: 'Designation for a sensor',
    message: 'Designation',
  },
  model: {
    notes: 'Model for a sensor',
    message: 'Model',
    values: {
      energy_harvesting: {
        notes: 'Sensor model energy_harvesting',
        message: 'Energy harvesting',
      },
      BG01960606: {
        notes: 'Sensor model BG01960606',
        message: 'BG01960606',
      },
    },
  },
  transceiver: {
    notes: 'Transceiver for a sensor',
    message: 'Transceiver',
  },
  macAddress: {
    notes: 'Mac address for a sensor',
    message: 'Mac address',
  },
};
